import React, { Component } from 'react';
import Conversations from './Conversations';
import MessageViewer from './MessageViewer';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {conversations: []};
  }

  search(e) {
    if (e) e.preventDefault();
    this.setVisible({showSearchResults: true, searching: true});
  }

  componentDidMount() {
    this.doConversationGet(this.props.neighbor);
  }

  selectConversation(convo_id, username=undefined) {
    let selectMe = this.props.app.state.conversations.filter(convo => convo._id['$oid'] === convo_id);
    if (selectMe) {
      this.props.app.showConversations(username, selectMe[0]);
    } else {
      console.log(' Unable to select conversation with ID: ' + convo_id);
    }
  }

  async doConversationGet(neighbor=null) {
    if (this.state.isFetching) {
      return;
    }
    if (this.state.totalConversations && this.props.conversations.length >= this.state.totalConversations) {
      this.setState({isFetching: false});
      return;
    }
    let url = window.location.protocol + '//' + window.location.host;
    let page = this.state.page || 1;
    try {
      let that = this;
      this.setState({isFetching: true});
      const d = await fetch(`/api/v1/conversations?include_latest_message=true&per_page=15&page=${page}`);
      d.json().then(data => {
        let selectedConversation = that.props.conversation;
        let found = false;
        let convos = data['conversations'], conversations = [];
        for (let i = 0; i < convos.length; i++) {
          let conv = convos[i];
          if (neighbor && conv['users'] && conv['users'].length === 2) { // will include ourselves..
            if (neighbor && conv['users'].length > 0) {
              for (let z = 0; z < conv['users'].length; z++) {
                if (conv['users'][z]['username'] === neighbor) {
                  found = true;
                  selectedConversation = conv;
                }
              }
            }
          }
          if (!selectedConversation) {
            selectedConversation = conv;
          }
          conversations.push(conv);
        }
        if (!found && neighbor) {
          try {
            let formData = new FormData();
            formData.append('conversation[neighbors][]', [neighbor]);
            const convoRequest = {
              uri: `${url}/api/v1/conversations`,
              method: 'POST',
              body: formData
            };
            fetch(convoRequest.uri, convoRequest).then(d2 => {
              d2.json().then(data => {
                let newConversation = data['conversations'];
                newConversation['loadme'] = true;
                let existingConversations = that.props.app.state.conversations;
                existingConversations.push(newConversation);
                that.props.app.showConversations(undefined, newConversation, existingConversations);
              });
            });
          } catch(ee) {
            console.log('[Conversations] Failed to  fetch conversation for ' + neighbor);
          }
        }
        // let totalConversations = jsonBody['meta']['total_conversations'];
        that.props.app.showConversations(undefined, selectedConversation, conversations);
        that.setState({isFetching: false});
      });
    } catch(e) {
      console.log('Error fetching conversations: ' + e);
    }
  }

  updateMessageStatuses(conversationId, unreadMessageCount) {
    let conversations = this.props.conversations;
    this.props.app.setState({messageCounter: unreadMessageCount});
    for (let i = 0; i < this.props.conversations.length; i++) {
      let checkConvo = this.props.conversations[i];
      if (checkConvo._id['$oid'] === conversationId) {
        checkConvo['has_unread'] = false;
        checkConvo['unreadMessage'] = false;
      }
    }
    this.props.app.setState({conversations: conversations});
  }

  render() {
    let convoId = undefined;
    if (this.props.conversation) {
      convoId = this.props.conversation._id.$oid;
    }
    let selectedConversationObject = this.props.conversation;
    if (!this.props.app.state.showSearchResults) {
      if (!this.props.conversation && this.props.conversations) {
        let c = this.props.conversations.filter(convo => convo['_id']['$oid'] === convoId)[0];
        if (c) {
          selectedConversationObject = c;
        }
      }
    }
    return(
      <div>
        <Conversations selectConversation={(conv_id) => this.selectConversation(conv_id)} user={this.props.user} area={this.props.area}
                       doConversationGet={() => this.doConversationGet()}
                       selectedConversation={selectedConversationObject} conversations={this.props.conversations} conversation_id={convoId}
                       app={this.props.app} neighbor={this.props.neighbor} ref={(ref) => this._conversationDiv = ref} />
        {!this.props.app.state.showSearchResults && selectedConversationObject
             && <MessageViewer updateMessageStatuses={(cid, unreadCount) => this.updateMessageStatuses(cid, unreadCount)} conversationId={convoId} user={this.props.user}
                               ref={(ref) => this._messageViewer = ref}
                               app={this.props.app} conversation={selectedConversationObject} />}
      </div>
    );
  }
}

export default App;
